<script setup>
import { computed } from 'vue';
import { Pie } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement } from 'chart.js';

const props = defineProps({
  collection: {
    type: Object,
    default: () => ({}),
  },
  chartOptions: {
    type: Object,
    default: () => ({}),
  },
});

ChartJS.register(Title, Tooltip, Legend, ArcElement);

const fontFamily =
  'Inter,-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif';

const defaultChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: {
      top: 10,
      bottom: 10,
      left: 10,
      right: 10,
    },
  },
  plugins: {
    legend: {
      display: true,
      position: 'bottom',
      align: 'center',
      labels: {
        fontFamily,
        padding: 15,
        usePointStyle: true,
        pointStyle: 'circle',
        boxWidth: 12,
        font: {
          size: 12,
        },
      },
    },
    tooltip: {
      enabled: true,
      callbacks: {
        label: context => {
          const label = context.label || '';
          const value = context.parsed || 0;
          return `${label}: ${value}%`;
        },
      },
    },
  },
  animation: {
    duration: 400,
  },
};

const options = computed(() => {
  return { ...defaultChartOptions, ...props.chartOptions };
});
</script>

<template>
  <Pie :data="collection" :options="options" />
</template>
